// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h3, h4, h5 {
    margin-top: 40px;
    margin-bottom: 20px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

#input-search {
   transition: width 0.4s ease-in-out;
   border-radius: 5px;
   height: 40px;
   padding-left: 20px;
   width: 40%;
   border: 1px solid gray;
   margin-left: 8px;
   box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
   font-size: 18px;
}

#input-search:focus {
   width: 80%;
}

.dataResult {
  margin-top: 5px;
  width: 320px;
  height: 200px;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-left: 10px;
}

.dataResultPTA {
  margin-top: 5px;
  width: 600px;
  height: 200px;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-left: 10px;
}

.dataResultPTA > p {
  padding: 4px;
  border-bottom: 1px dashed lightgray;
  font-size: 18px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.dataResult .dataItem {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  color: black;
  cursor: pointer;
  padding-left: 5px;
}

.dataResult .dataItem:hover {
  background-color: lightgrey;
}`, "",{"version":3,"sources":["webpack://./src/pages/Logistics/ExternalDeclaration/ExternalDeclaration.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;GACG,kCAAkC;GAClC,kBAAkB;GAClB,YAAY;GACZ,kBAAkB;GAClB,UAAU;GACV,sBAAsB;GACtB,gBAAgB;GAChB,uCAAuC;GACvC,eAAe;AAClB;;AAEA;GACG,UAAU;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["h3, h4, h5 {\n    margin-top: 40px;\n    margin-bottom: 20px;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n#input-search {\n   transition: width 0.4s ease-in-out;\n   border-radius: 5px;\n   height: 40px;\n   padding-left: 20px;\n   width: 40%;\n   border: 1px solid gray;\n   margin-left: 8px;\n   box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);\n   font-size: 18px;\n}\n\n#input-search:focus {\n   width: 80%;\n}\n\n.dataResult {\n  margin-top: 5px;\n  width: 320px;\n  height: 200px;\n  background-color: white;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin-left: 10px;\n}\n\n.dataResultPTA {\n  margin-top: 5px;\n  width: 600px;\n  height: 200px;\n  background-color: white;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin-left: 10px;\n}\n\n.dataResultPTA > p {\n  padding: 4px;\n  border-bottom: 1px dashed lightgray;\n  font-size: 18px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.dataResult .dataItem {\n  width: 100%;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  color: black;\n  cursor: pointer;\n  padding-left: 5px;\n}\n\n.dataResult .dataItem:hover {\n  background-color: lightgrey;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
